import script from "./UserToroku.vue?vue&type=script&setup=true&lang=js"
export * from "./UserToroku.vue?vue&type=script&setup=true&lang=js"

import "./UserToroku.vue?vue&type=style&index=0&id=6070f53a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6070f53a"]])

export default __exports__